<template>
  <div>
    <div class="container">
      <DirectSchoolTitle :title="title" />
      <DirectSchoolPhotos class="photos" :locations="locations" />
      <DirectSchoolLocation class="locations" :locations="locations" />
    </div>
    <a class="mobile call" :href="`tel:${locations[0].phone}`">
      <img src="../assets/mobile-home-call-btn.svg" />
    </a>
    <div class="map">
      <iframe
        :src="
          `https://maps.google.com/maps?q=${locations[0].address}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        "
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
      />
      <div class="cover" v-on:click="disableMapCover" v-if="!disableMap">
        <img src="../assets/watch-map.svg" />
        <div>點擊觀看地圖</div>
      </div>
    </div>
    <!-- <div class="container">
      <section class="people">
        <PersonalCard v-for="person in people"
                      class="person"
                      :key="person.name"
                      :person="person" />
      </section>
    </div> -->
  </div>
</template>

<script>
import DirectSchoolTitle from "@/components/DirectSchoolTitle.vue";
import DirectSchoolPhotos from "@/components/DirectSchoolPhotos.vue";
import DirectSchoolLocation from "@/components/DirectSchoolLocation.vue";
// import PersonalCard from "@/components/PersonalCard.vue";

export default {
  components: {
    DirectSchoolTitle,
    DirectSchoolPhotos,
    DirectSchoolLocation
    // PersonalCard
  },
  props: {
    title: String,
    locations: Array,
    people: Array
  },
  data() {
    return {
      disableMap: false
    };
  },
  methods: {
    disableMapCover() {
      this.disableMap = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 848px;
  margin: auto;
}

.photos,
.locations {
  margin: 30px 60px;
}

.map {
  width: 100%;
  height: 300px;
  position: relative;
  margin-bottom: 50px;

  iframe {
    width: 100%;
    height: 100%;
  }

  .cover {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 3;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > div {
      color: #0091d5;
      font-size: 16px;
      text-align: center;
    }
  }
}

.people {
  margin-top: 120px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;

  .person {
    flex: 1;
    box-sizing: border-box;
    padding: 0 10px;
  }
}

@media (max-width: 1023px) {
  .photos {
    margin: 22px 0 !important;
  }

  .locations {
    margin: 22px 10px !important;
  }

  .people {
    margin-top: 30px !important;
  }

  .call {
    text-align: center;
    margin: 30px auto;

    img {
      width: 155px;
    }
  }
}
</style>
